import { Subject } from "rxjs";

export interface Options {
    Selector: string | HTMLElement;
    Value: number;
    Min?: number;
    Max?: number;
}

export class AxCounter {
    private element: HTMLElement;
    private $QuantityCounter: JQuery<HTMLElement>;
    private value: number;

    private min: number;
    private max: number;
    private default: number;

    private observer: Subject<number>;

    Init(options: Options) {

        if (typeof options.Selector == "string") {
            let $e = $(options.Selector);
            if ($e.length !== 1) {
                throw `AxCounter::Element with selector '${options.Selector}' not found or not unique!`;
            }
            this.element = $e[0];
        } else {
            this.element = options.Selector;
        }

        this.value = options.Value;
        this.min = options.Min;
        this.max = options.Max;
        this.default = options.Value;

        this.$QuantityCounter = $(this.element).find(`*[data-quantity-selection]`);

        this.observer = new Subject<number>();

        this.UpdateQuantity();

        this.$QuantityCounter.prev('button').click(x => {
            this.DecreaseQuantity();
        });
        this.$QuantityCounter.next('button').click(x => {
            this.IncreaseQuantity();
        });
    }

    resetValue() {
        this.value = this.default;
        this.UpdateQuantity();
    }

    updateMin(min: number) {
        this.min = min;
        this.updateButtonState();
    }

    updateMax(max: number) {
        this.max = max;
        this.updateButtonState();
    }

    getElement() {
        return this.element;
    }

    setValue(value: number) {
        this.value = value;
        this.UpdateQuantity();
    }

    Subscribe(x: (x: number) => void) {
        return this.observer.subscribe(y => x(y));
    }

    getSubscription(): Subject<number> {
        return this.observer;
    }

    GetValue() {
        return this.value;
    }

    IncreaseQuantity() {
        if (this.max == null || this.max > this.value) {
            this.value++;
            this.observer.next(this.value);
            this.UpdateQuantity();
        }
    }

    DecreaseQuantity() {
        if (this.value > 0 && (this.min == null || this.value > this.min)) {
            this.value--;
            this.observer.next(this.value);
            this.UpdateQuantity();
        }
    }

    UpdateQuantity() {
        if (this.$QuantityCounter.is('input')) {
            this.$QuantityCounter.val(this.value.toString());
            return;
        }
        this.$QuantityCounter.html(this.value.toString());
        this.updateButtonState();
    }

    updateButtonState() {
        if (this.value == this.max) {
            this.$QuantityCounter.next('button').attr('disabled', 'disabeld');
        } else {
            this.$QuantityCounter.next('button').removeAttr('disabled');
        }
        if (this.value == this.min) {
            this.$QuantityCounter.prev('button').attr('disabled', 'disabeld');
        } else {
            this.$QuantityCounter.prev('button').removeAttr('disabled');
        }
    }
}
